import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Seguís cobrando lo mismo que hace dos años mientras los insumos subieron el 60%', 'Tenés la agenda llena pero a fin de mes los números no cierran como deberían', 'No tenés contratos ni consentimientos firmados — y eso es un riesgo legal real', 'Hacés los tratamientos de memoria, sin protocolos escritos que respalden tu trabajo', 'Querés subir precios pero no sabés cómo hacerlo sin perder clientas', 'Tus clientas no vuelven con la frecuencia que deberían y no sabés por qué'];
export function PainSection() {
  return <section className="py-24 px-6 bg-brand-white" data-id="element-121">
      <div className="max-w-3xl mx-auto" data-id="element-122">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-brand-purple mb-16 text-center" data-id="element-123">
          Trabajás mucho. Demasiado. Y aun así...
        </motion.h2>

        <div className="space-y-8 mb-16" data-id="element-124">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-5" data-id="element-125">
              <XCircle className="w-7 h-7 text-red-500 shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-126" />
              <p className="text-lg md:text-xl font-sans text-gray-800 leading-relaxed" data-id="element-127">
                {point}
              </p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center text-gray-500 italic text-lg md:text-xl" data-id="element-128">
          "Si te identificaste con al menos 2 de estos puntos, seguí leyendo."
        </motion.p>
      </div>
    </section>;
}